import React from 'react';

/**
 * @typedef {import('./copy-to-clipboard-button-types.d.ts').CopyToClipboardIconComponent} CopyToClipboardIconComponent
 * @type {CopyToClipboardIconComponent}
 */
export const CopyToClipboardIcon = ({ className }) => {
  return (
    <svg className={className} viewBox='0 0 12 12' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.7797 1.65539L10.3441 0.219844C10.2047 0.0790078 10.0125 0 9.81327 0H5.9789C5.15038 0 4.4789 0.671719 4.4789 1.5L4.47935 7.5C4.49999 8.32969 5.17265 9 5.99999 9H10.5C11.325 9 12 8.325 12 7.5V2.18555C12 1.9868 11.9203 1.79602 11.7797 1.65539ZM10.875 7.5C10.875 7.70709 10.7071 7.875 10.5 7.875H5.9789C5.77176 7.875 5.6039 7.70709 5.6039 7.5V1.50305C5.6039 1.29595 5.7718 1.12805 5.9789 1.12805H8.9789L8.99999 2.25C8.99999 2.66414 9.33585 3 9.74999 3H10.8539V7.5H10.875ZM6.37499 10.5C6.37499 10.7071 6.20708 10.875 5.99999 10.875H1.4789C1.27176 10.875 1.1039 10.7071 1.1039 10.5L1.12452 4.50234C1.12452 4.29525 1.29243 4.12734 1.49952 4.12734H3.74999V3H1.49976C0.67124 3 -0.000244141 3.67148 -0.000244141 4.5L-1.44531e-05 10.5C3.71094e-05 11.3273 0.671709 12 1.49999 12H5.99999C6.82499 12 7.49999 11.325 7.49999 10.5V9.75H6.39608L6.37499 10.5Z'
        fill='currentColor'
      />
    </svg>
  );
};
